// extracted by mini-css-extract-plugin
export default {"dragger":"Dragger_dragger__mIFT9"};